import { render, staticRenderFns } from "./RegisterPixKeyChooseOwner.vue?vue&type=template&id=86b0eb4c&"
import script from "./RegisterPixKeyChooseOwner.vue?vue&type=script&lang=js&"
export * from "./RegisterPixKeyChooseOwner.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPixKeyChooseOwner.vue?vue&type=style&index=0&id=86b0eb4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports